import React, { useEffect, useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import styles from "./styles.css";
import { FaSearch } from "react-icons/fa";

export const Forms = ({
  cnpj,
  setCnpj,
  alert,
  alertData,
  searchCliente,
}) => {
  const [showAlertCnpj, setShowAlertCnpj] = useState(alert);
  const [showAlertData, setShowAlertData] = useState(alertData);

  useEffect(() => {
    if (alert) {
      setShowAlertCnpj(true);
      const timer = setTimeout(() => setShowAlertCnpj(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [alert]);

  useEffect(() => {
    if (alertData) {
      setShowAlertData(true);
      const timer = setTimeout(() => setShowAlertData(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [alertData]);

  function formatCNPJCPF(value) {
    const digits = value.replace(/\D/g, "");
    if (digits.length <= 11) {
      return digits
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d)/, "$1.$2")
        .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    } else {
      return digits
        .replace(/^(\d{2})(\d)/, "$1.$2")
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1/$2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{2})\d+?$/, "$1");
    }
  }

  const handleChange = (e) => {
    const formattedCnpj = formatCNPJCPF(e.target.value);
    setCnpj(formattedCnpj);
  };

  return (
    <div>
      <img src="/assets/images/logo.png" className={"logo"} alt="Logo NF-SIG" />
      <h5 className={"titulo"}>Consulta de Notas Fiscais e Boletos</h5>

      <Form className={styles["form-style"]}>
        <Form.Group className="mb-1 mt-3" controlId="formBasicCNPJ">
          <Form.Control
            type="text"
            placeholder="Digite seu CNPJ ou CPF"
            value={cnpj}
            onChange={handleChange}
            className={"input-form"}
          />
        </Form.Group>

        {showAlertCnpj && <Alert variant="danger">CNPJ não encontrado!</Alert>}
        {showAlertData && <Alert variant="danger">Período inválido!</Alert>}

        <Button
          variant="danger"
          className={styles["btn-consulta"]}
          onClick={searchCliente}
        >
          Consultar <FaSearch />
        </Button>
      </Form>
    </div>
  );
};
